import {all, takeLatest, put} from 'redux-saga/effects';
import {requestStatisticsDashBoard} from './api';
import {ststisticsDashBoardSuccess} from './actions';

import {
    STATISTICS_DASHBOARD_ROUTE
} from './constants';

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{ststistics: *, type: string}>>}
 */
function* getDashBoardStatistics(actionObj) {
    const qstatistic = yield requestStatisticsDashBoard(actionObj.Data);

    if (qstatistic) {
        yield put(ststisticsDashBoardSuccess(qstatistic));
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchStatistics() {
    yield  takeLatest(STATISTICS_DASHBOARD_ROUTE, getDashBoardStatistics);
}

/**
 *
 * @returns {IterableIterator<AllEffect<IterableIterator<ForkEffect>>>}
 */
function* statisticsDashBoardSaga() {
    yield all([
        watchStatistics()
    ]);
}

export default statisticsDashBoardSaga;
